// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3272cc85","879":"6c13437e"}[chunkId] + ".chunk.js";
};